module.exports = __webpack_public_path__ + "assets/img/mc2.4ba5e6b1.png";